
import React, { useState } from 'react'
import Location from 'react-autosuggest'
import debounce from 'lodash/debounce'
import axios from '../../../Axios'
import { Urls } from '../../../Urls'
import styled from 'styled-components';
import { withRouter } from 'react-router-dom'
import classes from './AutoComplete.module.css'

const classNames = {
  container: 'react-autosuggest__container',
  input: 'react-autosuggest__input',
  inputFocused: 'react-autosuggest__input--focused',
  inputOpen: 'react-autosuggest__input--open',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted'
};
// display:contents;
// .${classNames.suggestionsContainer} {
//   display: none;
// }
const AutoSuggestWrapper = styled.div.attrs(classNames)`
  ${classNames.container} {
    position: absolute;
  }
  .${classNames.input} {
    width: 100%;
    height: 30px;
    padding: 10px 20px;
    font-weight: 300;
    font-size: 16px;
    border:none
  }
  .${classNames.inputFocused} {
    outline: none;
  }
  .${classNames.inputOpen} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .${classNames.suggestionsContainer} {
    display: none;
  }
  .${classNames.suggestionsContainerOpen} {
    display:contents;
    position: absolute;
    top: 51px;
    border: 1px solid #aaa;
    background-color: #fff;
    font-weight: 300;
    font-size: 12px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    max-height: 150px;
    overflow-y: scroll;
    z-index: 9999;
    height: auto;
    white-space: nowrap;
    width:100%
  }
  .${classNames.suggestionsList} {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .${classNames.suggestion} {
    cursor: pointer;
    padding: 3px 5px;
  }
  .${classNames.suggestionHighlighted} {
    background-color: #ddd;
  }
`;
const AutoComplete = ({
  onSelect,
  // className,
  placeholder,
  onChange,
  value = '',
  key,
  // deafultSuggestion = { transporter_name: 'ALL' },
  // country = "INDIA",
  getResults,
  // searchFields = 'transporter_name'

}) => {
  const [suggestions, setSuggestions] = useState([])
  const [show, setShow] = useState(false)

  const onSuggestionsFetchRequested = debounce(({ value }) => {
   
    if (value.length >= 3) {
     
      setShow(true)
      axios.post(`${Urls.Autocomplete.Get.getTransporterName}`,
        { transporter_name: value }
      )
        .then(res => {
          setSuggestions([])
          setSuggestions([...res.data.transporter_data])
          setShow(false)
        })
        .catch(err => {
          setShow(false)
        })
    }
  }, 500)
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  }
  const getSuggestionValue = (value) => {
    return value.transporter_name;
  }
  const renderSuggestion = (value) => {
    return value.transporter_name;
  }
  const onSuggestionSelected = (event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    onChange(suggestion.transporter_name)
    onSelect(suggestion.transporter_name)
    if (getResults)
      getResults(suggestion);


  }
  // const shouldRenderSuggestions = (value) => {
  //   return value.trim().length % 3 === 0
  // }

  const inputProps = {
    value: value,
    onChange: e => onChange(e.target.value),
    placeholder: placeholder,
    key: key,
    id: 'Autosuggets_Input_id',


  }
  return (
    <AutoSuggestWrapper className={`${classes['auto-spin']}`}>
      <Location
        suggestions={suggestions}
        onSuggestionsFetchRequested={value => onSuggestionsFetchRequested(value)}
        onSuggestionsClearRequested={e => onSuggestionsClearRequested()}
        getSuggestionValue={value => getSuggestionValue(value)}
        renderSuggestion={value => renderSuggestion(value)}
        onSuggestionSelected={onSuggestionSelected}
        inputProps={inputProps}
        theme={classNames}

      />
      {show ? <i className={`${classes['s-spin']} fa fa-spinner fa-spin`} /> : null}


    </AutoSuggestWrapper >

  )
}


export default withRouter(AutoComplete)
